import axios from 'axios'

const historicalChartApi = async (startDate, endDate) => {
  const result = await axios.get(`/charts/amperage_values?start=${startDate}&end=${endDate}`)
  return result.data
}

export default historicalChartApi